import { useContext } from 'react';
import {
    CalculatorInputFields,
    CalculatorInputFieldsType,
    CalculatorInputOptions,
} from '../utils/CalculatorInputValue';
import { CalculatorFieldsContext } from '../contexts/CalculatorContext';
import { CalculatorHtmModeContext } from '../../../shared/contexts/CalculatorContext';
import { CalculatorHTMMode } from '../../../shared/classes/CalculatorMode';

export function SharedSelect({inputName}: { inputName: keyof CalculatorInputFieldsType }): JSX.Element | null {
    const [calculatorValue, setCalculatorValue] = useContext(CalculatorFieldsContext)!;
    const label = CalculatorInputFields.find(e => e.key === inputName)?.label;
    const valueList = CalculatorInputOptions[inputName]?.valueList || [];
    const options = CalculatorInputOptions[inputName];
    const isHTMMode = options?.isHTMMode || false;
    const calculatorMode = useContext(CalculatorHtmModeContext)!;

    return !isHTMMode || calculatorMode[0] === CalculatorHTMMode.HTM
        ? (
            <div className={(isHTMMode ? 'advancedMode ' : '') + 'selectValue'}>

                <label htmlFor={inputName}>{label}</label>
                {/*<div></div>*/}
                <span className="select-style">
                    <select id={inputName}
                            onChange={event => setCalculatorValue({
                                ...calculatorValue,
                                [inputName]: event.target.value
                            })}
                            value={calculatorValue[inputName] || ''}>
                        {
                            valueList?.map((e, i) => {
                                return (
                                    <option key={i}
                                            value={e.code}>
                                        {e.label}
                                    </option>
                                );
                            }) || ''
                        }
                    </select>
                </span>
            </div>
        )
        : null;
}
